import { ObjectDeserializer } from 'object-deserializer';
import { Price } from './interfaces';

export function priceDeserializer(o: ObjectDeserializer): Price {
  return {
    description: o.required('Description').asString,
    price: o.required('Price').asNumber,
    tickets: o.required('Tickets').asNumber,
  };
}
